import { AutoCompleteMulti } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { IOfferClassificationClassificationsProps } from "./models";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.ticketAutomationReceivedRuleOfferClassif.";

export const OfferClassificationClassifications = ({
  options,
}: IOfferClassificationClassificationsProps) => {
  const { t } = useTranslation();

  return (
    <Grid item xs={12} sm={12}>
      <AutoCompleteMulti
        name="classifications"
        label={t(translationPath + "classifications")}
        getOptionLabel={({ name }) => name}
        options={options}
        size="small"
        keepOpenOnSelect
      />
    </Grid>
  );
};
